// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DrrpDengjibIconOutlinedSvg from "@fishx/icons-svg/es/asn/DrrpDengjibIconOutlined";
import FishxIcon from '../components/FishxIcon';

var DrrpDengjibIconOutlined = function DrrpDengjibIconOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: DrrpDengjibIconOutlinedSvg
  }));
};

DrrpDengjibIconOutlined.displayName = 'DrrpDengjibIconOutlined';
export default React.forwardRef(DrrpDengjibIconOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/DrrpDengjibIconOutlined.js
// module id = 2551
// module chunks = 0